import { useQuery } from "react-query";
import { getModelRole } from "~/pages/RegistryOfRole/rolesRequest/getModelRole";

export default function useGetModelRole() {
  return useQuery({
    queryKey: ["getModelRole"],
    queryFn: () => getModelRole(),
    refetchOnWindowFocus: false,
    // enabled,
    cacheTime: 0,
  });
}
